
export default function useAbTestGroup(router) {
  return { abTestGroup: (router?.query?.abTestGroup || '')?.toUpperCase(), };
}
